<script>
import BaseLayout from '@/components/shared/layout/BaseLayout'
import platformDetect from '@/mixins/platformDetect'
export default {
  name: 'hello',
  data () {
    return {
      containers: '',
      isVisible: true,
      date_de_diffusion: '',
    }
  },
  mixins: [
    platformDetect,
    // getUsagerStatistiques,
  ],
  components: {
    BaseLayout,
  },
  methods: {
  },
  mounted () {
    var body = document.getElementById('app')
    body.style.overflow = 'hidden'
    setTimeout(function () {
      // console.log('tete')
      this.isVisible = false
      // console.log(this.isVisible)
      var temp = document.getElementsByClassName('cd-transition-layer')
      temp[0].style.visibility = 'hidden'
      temp[0].style.position = 'fixed'
    }, 10000)
  },
}
</script>
<template lang="pug">
base-layout(style='padding-top=-2rem;')
  div.cd-transition-layer(v-bind:class="{ visible: isVisible }")
   //- div(class='bg-layer')
  div.bgblackintro
  div.backgroundtexture
  div.animatedgradient
  div.hello
    div.logosintro
      div.story.fr
        router-link(:to="{ name: 'story'}")
          img.logoresizing.pb3(src="~@/assets/The_Story_Button.png")
      div.song.fr
        router-link(:to="{ name: 'songs'}")
          img.logoresizing.pb3(src="~@/assets/The_Songs_Button.png")
      div.film.fr
        router-link(:to="{ name: 'film'}")
          img.logoresizing.pb3(src="~@/assets/The_Film_Button.png")
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*ANIMATIONS*/
.cd-transition-layer {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 200;
  height: 100%;
  width: 100%;
  opacity: 0;
  /*visibility: hidden;
  overflow: hidden;*/
}
.cd-transition-layer, .bg-layer{
  position: absolute;
  left: 50%;
  top: 50%;
  height: calc(100vw * 0.5625);
  width: calc(100vw * 100);
  /*width: calc(39680px / 9vw);*/
  background: url("~@/assets/transitions/montage_intro_transition.jpg") no-repeat 0 0;
  background-size: 100% 100%;
}

.bgblackintro{
  position:fixed;
  height:100vh;
  width:100vw;
  background-color: black;
  -moz-animation: fadeOut 2s 4s;
  -webkit-animation: fadeOut 2s 4s;
  animation: fadeOut 2s 4s;
  animation-fill-mode: both;
  -moz-animation-fill-mode: both;
  -webkit-animation-fill-mode: both;
}
@keyframes cd-sequence {
  0% {
    transform: translateY(-50%) translateX(-0.50%);
    opacity: 0;
  }
  25% {
    opacity: 1;
  }
  75% {
    opacity: 1;
  }
  100% {
    transform: translateY(-50%) translateX(-100.50%);
    opacity: 1;
  }
}
.cd-transition-layer.visible {
  /*animation: cd-sequence 2.15s steps(62);*/
  animation: cd-sequence 3.7523s steps(100);
  animation-fill-mode: normal;
  /*animation-direction: reverse;*/
  /*animation-timing-function: ease-in;*/
  animation-iteration-count: 1;
  visibility: visible;
}
.backgroundtexture{
  -moz-animation: fadeIn 7s;
  -webkit-animation: fadeIn 7s;
  animation: fadeIn 7s;
  animation-fill-mode: both;
  -moz-animation-fill-mode: both;
  -webkit-animation-fill-mode: both;
}
.animatedgradient{
background: linear-gradient(45deg, #7c2121, #bc2d1e, #ef0505, #10e52b, #1bc01a, #197a1d);
background-size: 1200% 1200%;
width:100vw;
opacity:0.5;
height:100vh;
z-index:-9;
position:absolute;
mix-blend-mode:hard-light;
-webkit-animation: AnimationName 35s ease infinite;
-moz-animation: AnimationName 35s ease infinite;
-o-animation: AnimationName 35s ease infinite;
animation: AnimationName 35s ease infinite;
}
@-webkit-keyframes AnimationName {
    0%{background-position:0% 46%}
    50%{background-position:100% 55%}
    100%{background-position:0% 46%}
}
@-moz-keyframes AnimationName {
    0%{background-position:0% 46%}
    50%{background-position:100% 55%}
    100%{background-position:0% 46%}
}
@-o-keyframes AnimationName {
    0%{background-position:0% 46%}
    50%{background-position:100% 55%}
    100%{background-position:0% 46%}
}
@keyframes AnimationName {
    0%{background-position:0% 46%}
    50%{background-position:100% 55%}
    100%{background-position:0% 46%}
}
/*ANIMATIONS END*/

@media only screen and (min-width: 320px){
  .backgroundtexture{
    background-image: url("~@/assets/imgs_bg/fond3.jpg");
    background-size: cover;
    background-position: center;
    height: 100%;
    min-height: 100vh;
    width:100vw;
    z-index:-10;
    position:absolute;
  }
  .hello{
    height:100vh;
    padding-top: 35%;
    & .logosintro{
      display:inline;
      & .logoresizing{
        width:200px;
      }
      & .song{
        width: 100%;
        -moz-animation: fadeInDown 1.5s 4.5s;
        -webkit-animation: fadeInDown 1.5s 4.5s;
        animation: fadeInDown 1.5s 4.5s;
        animation-fill-mode: both;
      }
      & .story{
        width: 100%;
        -moz-animation: fadeInDown 1.5s 4s;
        -webkit-animation: fadeInDown 1.5s 4s;
        animation: fadeInDown 1.5s 4s;
        animation-fill-mode: both;
      }
      & .film{
        width: 100%;
        -moz-animation: fadeInDown 1.5s 5s;
        -webkit-animation: fadeInDown 1.5s 5s;
        animation: fadeInDown 1.5s 5s;
        animation-fill-mode: both;
      }
    }
  }
}
@media only screen and (min-width: 320px) and (orientation:landscape) {
  .hello{
    height:100vh;
    padding-top: 20%;
    & .logosintro{
      display:inline;
      & .song{
        width: 33%;
      }
      & .story{
        width: 33%;
        margin-bottom:100px;
      }
      & .film{
        width: 33%;
      }
    }
  }
}
@media only screen and (min-width: 768px){
  .cd-transition-layer, .bg-layer{
    filter:blur(2px);
  }
  .hello{
    height:100vh;
    padding-top: 200px;

    & .logosintro{
      display:inline;
      & .logoresizing{
        width:250px;
        margin:20px 0px 20px 0px;
      }
      & .song{
        width: 100%;
        /*margin-right:10%;*/
      }
      & .story{
        width: 100%;
        /*margin-bottom:100px;*/
      }
      & .film{
        width: 100%;
        /*margin-left:10%;*/
      }
    }
  }
}
@media only screen and (min-width: 768px) and (orientation:landscape) {
  .hello{
    height:100vh;
    padding-top: 350px;
    & .logosintro{
      display:flex;
      justify-content: center;
      & .logoresizing{
        width:250px;
        margin:0 40px 0 40px;

      }
      & .song{
        width: 300px;
        /*margin-right:25%;*/
      }
      & .story{
        width:300px;
        /*margin-bottom:100px;*/

      }
      & .film{
        width: 300px;
        /*margin-left:25%;*/
      }
    }
  }
}
@media only screen and (min-width: 1200px){
  .cd-transition-layer, .bg-layer{
    filter:blur(3px);
  }
  .hello{
    height:100vh;
    padding-top: 350px;
    & .logosintro{
      display:flex;
      justify-content: center;
      & .logoresizing{
        width:300px;
        /*margin:0 40px 0 40px;*/

      }
      & .song{
        width: 300px;
        /*margin-right:25%;*/
      }
      & .story{
        width:300px;
        /*margin-bottom:100px;*/

      }
      & .film{
        width: 300px;
        /*margin-left:25%;*/
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// Hello.vue?4037550a